import { callable } from './callable'

export type SetHelperAppAccessPayload = {
  workspaceId: string
  uid: string
  appAccess: boolean
}

export type SetHelperAppAccessResponse = {
  ok: boolean
  appAccess: boolean
}

export const setHelperAppAccess = async (
  input: SetHelperAppAccessPayload,
): Promise<SetHelperAppAccessResponse> => {
  return callable('setHelperAppAccess', input)
}
